import React, { Component } from 'react';
import 'fullcalendar/dist/fullcalendar.css';
//import 'fullcalendar/dist/fullcalendar.print.min.css';
import 'fullcalendar/dist/fullcalendar.js';
import '../resources/css/ReservationForm.css';
import {firebaseDb} from '../lib/firebase/firebase';
import ClientForm from './ClientForm';
import {
  formatDate,
  formatTime, 
  validateEmail,
} from '../utils/lib';
import { 
  Modal,
} from 'react-bootstrap/lib';
var SHA256 = require("crypto-js/sha256");

class ClientInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noteText:'',
    };
  }

  componentDidMount(){
    var _self = this;
    if(this.props.client){
      _self.setState({client:this.props.client})
    }else{
      firebaseDb.ref("clients/" + this.props.clientId).once('value',function(snap){
        _self.setState({client:snap.val()})
      })
    }
  }

  render(){
    if(this.state.client){
      return (
        <div>
          <div className="row">
            <div className="col-md-6">
              <p><span className="glyphicon glyphicon-user" aria-hidden="true"></span> {this.state.client.name}</p>
              <p><a>Remove <span onClick={this.props.onRemove} className="glyphicon glyphicon-remove" aria-hidden="true"></span></a></p>
            </div>
            <div className="col-md-6" style={{textAlign:'right'}}>
              <p>{this.state.client.phone} <span className="glyphicon glyphicon-earphone" aria-hidden="true"></span></p>
              <p>{this.state.client.email} <span className="glyphicon glyphicon-envelope" aria-hidden="true"></span></p>
            </div>
          </div>
        </div>
      );
    }else{
      return (
        <div>
          <h4>Loading reservation</h4>
          <p>...</p>
        </div>
      );
    }
  }
}
// Specifies the default values for props:
ClientInfo.defaultProps = {
  onClear:()=>console.log('Clear form'),
  onRemove:()=>console.log('Remove form'),
}

class ReservationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      client:{
        email:"",
        name:"",
        phone:"",
      },
      clientSearch:'',
      selectedCategory:"null",
      selectedSubCategory:"null",
      clientsOptionsByEmail:{},
      clientsOptionsByPhone:{},
      clientsOptionsByName:{},
      selectedTags:{},
      selectedStaff:'',
      selectedClient:undefined,
      selectedClientId:undefined,
      showNewClientModal: false,
    };
  }

  closeNewClientModal() {
    this.setState({ showNewClientModal: false });
  }

  openNewClientModal() {
    this.setState({ showNewClientModal: true ,});
  }

  componentDidMount(){
    var _self = this;
    firebaseDb.ref("tags").orderByChild('venue').equalTo(this.props.selectedVenue).once('value',function(snap){
      _self.setState({tags:snap.val()})
    })
  }

  searchClient(){
    this.searchClientByEmail(this.state.clientSearch)
    this.searchClientByPhone(this.state.clientSearch)
    this.searchClientByName(this.state.clientSearch)
  }

  searchClientByEmail(text){
    var _self = this;
    if(text!=""){
      firebaseDb.ref("clients").orderByChild("email").startAt(text).once('value',function(client){
        if(client.exists()){
          _self.setState({clientsOptionsByEmail:client.val()});
        }else{
            _self.setState({clientsOptionsByEmail:{}});
        }
      });
    }else{
      _self.setState({clientsOptionsByEmail:{}});
    }
  }

  searchClientByPhone(text){
    var _self = this;
    if(text!=""){
      firebaseDb.ref("clients").orderByChild("phone").startAt(text).once('value',function(client){
        if(client.exists()){
          _self.setState({clientsOptionsByPhone:client.val()});
        }else{
            _self.setState({clientsOptionsByPhone:{}});
        }
      });
    }else{
      _self.setState({clientsOptionsByPhone:{}});
    }
  }

  searchClientByName(text){
    var _self = this;
    if(text!=""){
      firebaseDb.ref("clients").orderByChild("name").startAt(text).once('value',function(client){
        if(client.exists()){
          _self.setState({clientsOptionsByName:client.val()});
        }else{
          _self.setState({clientsOptionsByName:{}});
        }
      });      
    }else{
      _self.setState({clientsOptionsByName:{}});
    }
  }

  handleChangeClientSearch(event) {
    this.setState({clientSearch:event.target.value},this.searchClient.bind(this));
  }

  handleChangeEmail(event) {
    var client = this.state.client;
    client["email"]=event.target.value;
    this.setState({client},this.searchClientByEmail.bind(this));
  }

  handleChangeName(event) {
    var client = this.state.client;
    client["name"]=event.target.value;
    this.setState({client},this.searchClientByName.bind(this));
  }

  handleChangePhone(event) {
    var client = this.state.client;
    client["phone"]=event.target.value;
    this.setState({client},this.searchClientByPhone.bind(this));
  }

  handleCreateClick(event) {
    var isValid = this.validateReservation();
    if(isValid.valid){
      var client_id = this.state.selectedClientId;
      var reservation = {
        client:client_id,
        email:this.state.selectedClient.email,
        name:this.state.selectedClient.name,
        phone:this.state.selectedClient.phone,
        created_by:this.props.user.id,
        created_at:(new Date()).toISOString(),
        start_date:this.props.selectedDateRange.start.split("T")[0],
        start_time:this.props.selectedDateRange.start.split("T")[1],
        start_datetime:this.props.selectedDateRange.start,
        end_datetime:this.props.selectedDateRange.end,
        end_date:this.props.selectedDateRange.end.split("T")[0],
        end_time:this.props.selectedDateRange.end.split("T")[1],
        date:this.transformDate(this.props.selectedDateRange.start),
        venue:this.props.selectedVenue,
        category:this.state.selectedCategory,
        sub_category:this.state.selectedSubCategory,
        tags:this.state.selectedTags,
        asignee:this.state.selectedStaff!=''?this.state.selectedStaff:null,
        color:this.state.selectedStaff!=''?this.props.staff[this.state.selectedStaff].color:null,
      }
      var id = firebaseDb.ref("reservations").push(reservation).key;
      firebaseDb.ref("venues/"+this.props.selectedVenue+"/reservations/"+id).set(this.transformDate(this.props.selectedDateRange.start));
      //firebaseDb.ref("clients/"+client_id).set(this.state.selectedClient);
      //firebaseDb.ref("venues/" + this.props.selectedVenue + "/clients/"+client_id).set(true);
      this.setState({message:{type:"success",text:"Reservation created successfully!"}},this.clearForm.bind(this))
    }else{
      this.setState({message:{type:"danger",text:isValid.message}})
    }
  }

  validateReservation(){
    if(this.state.selectedClient.email==="" || !validateEmail(this.state.selectedClient.email))
      return {valid:false,message:'Invalid email.'};
    if(this.state.selectedClient.name==="")
      return {valid:false,message:'Invalid name.'};
    if(this.state.selectedClient.phone==="")
      return {valid:false,message:'Invalid phone.'};
    if(this.props.selectedDateRange.start==="")
      return {valid:false,message:'Invalid range.'};
    if(this.props.selectedDateRange.end==="")
      return {valid:false,message:'Invalid range.'};
    if(
        this.props.categories==undefined || 
        this.props.categories[this.state.selectedCategory]==undefined
      )
      return {valid:false,message:'Invalid category.'};
    if(
        this.props.categories==undefined ||
        this.props.categories[this.state.selectedCategory]==undefined ||
        this.props.categories[this.state.selectedCategory].sub_categories[this.state.selectedSubCategory]==undefined
      )
      return {valid:false,message:'Invalid sub category.'};

    return {valid:true,}
  }

  transformDate(date){
    if(date!=""){
      var d = date.split("T")[0].split("-");
      d.map((a)=>parseInt(a));
      var t = date.split("T")[1].split(":");
      t.map((a)=>parseInt(a));
      return (new Date(d[0],d[1]-1,d[2],t[0],t[1])).toISOString();
    }else{
      return null;
    }
  }

  formatRangeDate(date){
    if(date!=""){
      var d = date.split("T")[0].split("-");
      d.map((a)=>parseInt(a));
      var t = date.split("T")[1].split(":");
      t.map((a)=>parseInt(a));
      return formatDate(d[0],d[1]-1,d[2])+", "+formatTime(t[0],t[1]);
    }else{
      return (
        "No date selected"
      );      
    }
  }

  clearForm(){
    this.setState({
      selectedClient:undefined,
      selectedClientId:undefined,
      clientSearch:"",
      selectedCategory:"null",
      selectedSubCategory:"null",
      clientsOptions:{},
      selectedTags:{},
      selectedStaff:undefined,
      clientsOptionsByEmail:{},
      clientsOptionsByPhone:{},
      clientsOptionsByName:{},
    },this.props.onClear);
  }

  selectClient(id,client){
    this.setState({selectedClientId:id,selectedClient:client})
  }

  unselectClient(){
    this.setState({selectedClientId:undefined,selectedClient:undefined})
  }

  getCategories(){
    var items = [];
    var venue = (this.props.categories && this.props.venues && this.props.venues[this.props.selectedVenue])?this.props.venues[this.props.selectedVenue]:{};
    items.push(
      <option key={"null"} value={"null"}>Select a category</option>
    );
    for(var c in venue.categories){
      items.push(
        <option key={c} value={c}>{this.props.categories[c].name}</option>
      );
    }
    return items;
  }

  getSubCategories(){
    var items = [];
    var category = (this.props.categories && this.props.categories[this.state.selectedCategory])?this.props.categories[this.state.selectedCategory]:{};
    items.push(
      <option key={"null"} value={"null"}>Select a sub-category</option>
    );
    for(var s in category.sub_categories){
      items.push(
        <option key={s} value={s}>{this.props.categories[this.state.selectedCategory].sub_categories[s].name}</option>
      );
    }
    return items;
  }

  getClientsOptions(){
    var items = [];
    for(var c in this.state.clientsOptionsByName){
      items.push(
        <tr key={c} style={{cursor:'pointer'}}>
          <td>
          <a onClick={this.selectClient.bind(this,c,this.state.clientsOptionsByName[c])} className="" key={c}>
              {this.state.clientsOptionsByName[c].name}
            </a>
          </td>
          <td>
          <a onClick={this.selectClient.bind(this,c,this.state.clientsOptionsByName[c])} className="" key={c}>
              {this.state.clientsOptionsByName[c].email}
            </a>
          </td>
          <td>
          <a onClick={this.selectClient.bind(this,c,this.state.clientsOptionsByName[c])} className="" key={c}>
              {this.state.clientsOptionsByName[c].phone}
            </a>
          </td>
        </tr>
      );
    }
    for(var c in this.state.clientsOptionsByPhone){
      items.push(
        <tr key={c} style={{cursor:'pointer'}}>
          <td>
          <a onClick={this.selectClient.bind(this,c,this.state.clientsOptionsByPhone[c])} className="" key={c}>
              {this.state.clientsOptionsByPhone[c].name}
            </a>
          </td>
          <td>
          <a onClick={this.selectClient.bind(this,c,this.state.clientsOptionsByPhone[c])} className="" key={c}>
              {this.state.clientsOptionsByPhone[c].email}
            </a>
          </td>
          <td>
          <a onClick={this.selectClient.bind(this,c,this.state.clientsOptionsByPhone[c])} className="" key={c}>
              {this.state.clientsOptionsByPhone[c].phone}
            </a>
          </td>
        </tr>
      );
    }
    for(var c in this.state.clientsOptionsByEmail){
      items.push(
        <tr key={c} style={{cursor:'pointer'}}>
          <td>
            <a onClick={this.selectClient.bind(this,c,this.state.clientsOptionsByEmail[c])} className="" key={c}>
              {this.state.clientsOptionsByEmail[c].name}
            </a>
          </td>
          <td>
            <a onClick={this.selectClient.bind(this,c,this.state.clientsOptionsByEmail[c])} className="" key={c}>
              {this.state.clientsOptionsByEmail[c].email}
            </a>
          </td>
          <td>
            <a onClick={this.selectClient.bind(this,c,this.state.clientsOptionsByEmail[c])} className="" key={c}>
              {this.state.clientsOptionsByEmail[c].phone}
            </a>
          </td>
        </tr>
      );
    }
    if(items.length>0){
      items = (
        <table className="table table-hover table-responsive" style={{maxHeight:200,overflow:'scroll'}}>
          <thead>
            <tr>
              <th>
                Name
              </th>
              <th>
                Email
              </th>
              <th>
                Phone
              </th>
            </tr>
          </thead>
          <tbody>
            {items}
          </tbody>
        </table>
      );
    }
    return items;
  }

  onHandleCategoriesSelect(event){
    var selectedCategory = event.target.value;
    this.setState({selectedCategory})
  }

  onHandleSubCategoriesSelect(event){
    var selectedSubCategory = event.target.value;
    this.setState({selectedSubCategory})
  }

  onPressStaff(staff_id){
    var selectedStaff = this.state.selectedStaff;
    if(selectedStaff==staff_id){
      selectedStaff = undefined;    
    }else{
      selectedStaff = staff_id;
    }
    this.setState({selectedStaff})
  }

  getVenueStaff(){
    var items = [];
    var staff = this.props.staff;
    for(var u in staff){
      if(staff[u].status=='ACTIVE'){
        var selected = this.state.selectedStaff==u;
        items.push(
          <a onClick={this.onPressStaff.bind(this,u)} id={u} style={{cursor:'pointer',textDecorationLine:'none',}}><span style={selected?{cursor:'pointer',textDecorationLine:'none',borderRadius:5,padding:5,color:'#FFFFFF',backgroundColor:(this.props.staff?this.props.staff[u].color:"#FFFFFF")}:{cursor:'pointer',textDecorationLine:'none',borderRadius:5,padding:5,color:(this.props.staff?this.props.staff[u].color:"#FFFFFF"),borderColor:(this.props.staff?this.props.staff[u].color:"#FFFFFF"),borderWidth:1,borderStyle:'solid'}}>{this.props.staff[u].name}</span></a>
        );
      }
    }
    if(items.length===0){
      items.push(
        <span id={"no-data"} key={"no-data"}>No data</span>
      );
    }
    return items;
  }


  onPressTag(tag_id){
    var selectedTags = this.state.selectedTags;
    selectedTags[tag_id] = !(selectedTags[tag_id]==true);
    this.setState({selectedTags})
  }

  getVenueTags(){
    var items = [];
    var tags = this.state.tags;
    for(var u in tags){
      if(tags[u].status=='ACTIVE'){
        var selected = this.state.selectedTags[u]?true:false;
        items.push(
          <a onClick={this.onPressTag.bind(this,u)} id={u} style={{cursor:'pointer',textDecorationLine:'none',}}><span style={!selected?{cursor:'pointer',textDecorationLine:'none',borderRadius:5,padding:5,color:'#888',borderColor:'#888',borderWidth:1,borderStyle:'solid',}:{cursor:'pointer',textDecorationLine:'none',borderRadius:5,padding:5,color:'#FFF',backgroundColor:'#888',borderColor:'#888',borderWidth:1,borderStyle:'solid',}}>{this.state.tags[u].name}</span></a>
        );
      }
    }
    if(items.length===0){
      items.push(
        <span id={"no-data"} key={"no-data"}>No data</span>
      );
    }
    return items;
  }

  onClickAddUser(){
    this.openNewClientModal();
  }

  render() {
    var message = [];
    if(this.state.message){
      message = (
        <div className={"alert alert-"+this.state.message.type}>
          {this.state.message.text}
        </div>
      );
    }
    var categories = this.getCategories();
    var subCategories = this.getSubCategories();
    var clientsOptions = this.getClientsOptions();
    var client = [];
    if(this.state.selectedClient){
      client = (
        <div className="col-xs-12">
          <ClientInfo user={this.props.user} clientId={this.state.selectedClientId} client={this.state.selectedClient} onRemove={this.unselectClient.bind(this)}/>
        </div>
      );
    }else{
      client = [
        (<div className="col-xs-12">
                  <label>Client</label>
                  <div className="form-group">
                    <div className="input-group">
                      <span className="input-group-addon"><span className="glyphicon glyphicon-search" aria-hidden="true"></span></span>
                      <input type="email" className="form-control" placeholder="Search client..." value={this.state.clientSearch} onChange={this.handleChangeClientSearch.bind(this)}/>
                      <span className="input-group-btn">
                        <a className="btn btn-primary btn-block" onClick={this.onClickAddUser.bind(this)}>Add</a>
                      </span>
                    </div>
                  </div>
                </div>),
        (<div className="form-group col-xs-12">
                  {clientsOptions}
                </div>)
      ];
    }
    var tags = this.getVenueTags();
    var staff = this.getVenueStaff();
    return (
      <form>
        <div className="row">
          <div className="form-group col-md-6">
            <label>Start at</label>
            <p className="">
              {this.formatRangeDate(this.props.selectedDateRange.start)}
            </p>
          </div>
          <div className="form-group col-md-6">
            <label>End at</label>
            <p className="">
              {this.formatRangeDate(this.props.selectedDateRange.end)}
            </p>
          </div>
          <div className="form-group col-xs-12">
            <label>About what?</label>
            <br/>
            <select value={this.state.selectedCategory} onChange={this.onHandleCategoriesSelect.bind(this)} className="form-control" id="select">
              {categories}
            </select>
          </div>
          <div className="form-group col-xs-12">
            <select value={this.state.selectedSubCategory} onChange={this.onHandleSubCategoriesSelect.bind(this)} className="form-control" id="select">
              {subCategories}
            </select>
          </div>
          {client}
          <div className="form-group col-xs-12">
            <div>
              {staff}
            </div>
          </div>
          <div className="form-group col-xs-12">
            <div>
              {tags}
            </div>
          </div>
          <div className="form-group col-xs-12">
            {message}
            <a onClick={this.clearForm.bind(this)} className="btn btn-default pull-right">Clear</a>
            <a onClick={this.handleCreateClick.bind(this)} className="btn btn-primary"><span className="glyphicon glyphicon-plus" aria-hidden="true"></span> Create</a>
          </div>
        </div>

        <Modal show={this.state.showNewClientModal} onHide={this.closeNewClientModal.bind(this)}>
          <div>
            <Modal.Body>

              <ClientForm 
                user={this.props.user}
                selectedVenue={this.props.selectedVenue}
                venues={this.props.venues}
                categories={this.props.categories}
                staff={this.props.staff}
                onCreate={function(data){
                  console.log(data)
                  this.closeNewClientModal();
                  this.selectClient(data.client_id,data);
                }.bind(this)}
                tags={this.props.tags}/>

            </Modal.Body>
          </div>
        </Modal>

      </form>
    );
  }
}
// Specifies the default values for props:
ReservationForm.defaultProps = {
  selectedDateRange:{
    start:"",
    end:"",
  },
  onClear:()=>console.log('Clear form'),
}
export default ReservationForm;



// WEBPACK FOOTER //
// ./src/components/ReservationForm.js